import React, {Component} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import PopUp from '../elements/PopUp';

import history from "../../history.js";
import { __ } from 'i18n-for-browser';
import actions from '../../actions';
import {checkRead} from "../../helpers/feedbackHelpers";
import Warning from "../../assets/img/icons/warning.svg";
import Save from "../../assets/img/save.svg";

import {choicesToMake, getOplossingen, groupByProblem} from '../../helpers/policyChoiceHelper';
import {
  calculateBudgetBASIC,
  calculateBudgetPRO,
  calculateSavingsAndLoans
} from '../../helpers/calculationsHelper';
import {getSavedGlobas} from "../../helpers/bankHelper";

let desktop = false;

if (document.querySelector('#root').clientWidth >= 1240) {
  desktop = true;
}

const { submitMyState, updateMyState } = actions.gameStateInput;

class NextStep extends Component {
  static propTypes = {
    unlocked: PropTypes.bool,
  };
  static defaultProps = {
    unlocked: true,
  };
  constructor(props) {
    super(props);
    this.state = {
      showPopUp: false,
      showWarning: '',
      showWarningId: '',
    };
    this.togglePopUp = this.togglePopUp.bind(this);
  }

  // Getter to check if next step is available
  get unlocked () {
    const { gameState, feedback, unlocked, gameStateInput } = this.props;
    const unreadCount = this.unreadFeedback(feedback.prevRoundFeedbackData.concat(feedback.feedbackData), gameState.currentStep);
    if (gameState.activatedStep === 2 && !gameState.roundData.step3Active) {
      return false;
    }
    return !gameStateInput.preventInputChanges && unlocked && gameState.nextStepUnlocked && unreadCount === 0;
  }

  togglePopUp = () => {
    if (!this.unlocked) {
      this.setState({
        showPopUp: !this.state.showPopUp
      })
    }
  };

  handleClick = () => {
    const { gameState } = this.props;
    if (!this.unlocked) {
      this.togglePopUp();
      return;
    }
    this.props.dispatch(updateMyState({ activatedStep: gameState.currentStep += 1 }));
    // window.location.reload();
  };

  getDescription = () => {
    const { gameState, feedback, project } = this.props;

    const unreadCount = this.unreadFeedback(feedback.prevRoundFeedbackData.concat(feedback.feedbackData), gameState.currentStep);

    let message = {desc: `${__('sim_pas_verder_met_stap_warning_part_1')} ${(gameState.currentStep + 1)} ${__('sim_pas_verder_met_stap_warning_part_2')}`};
    if(gameState.currentStep + 1 === 2) {
      message = {id: 'dhgmstap2'};
      if (unreadCount > 0) {
        return {id: 'dhgmstap2_2'};
      }
    } else if(gameState.currentStep + 1 === 3) {
      console.log(gameState, unreadCount);
      if (unreadCount > 0 || gameState.roundData.state.startsWith('SIMULATION_TAX')) {
        return { id: (project.difficulty === 'PRO' ? 'dhgmstap3' : 'dlgmstap3') };
      } else {
        return { id: (project.difficulty === 'PRO' ? 'dhgmstap3_2' : 'dlgmstap3_2') };
      }
    }
    return message;
  }

  unreadFeedback (feedback = [], currentStep) {
    return feedback.reduce((count, fb) => {
      if (currentStep === 1) {
        if (fb.type !== 'BELASTING') {
          count += checkRead(fb) ? 0 : 1;
        }

        fb.overigeEffecten.forEach((oe, i) => {
          if (!checkRead(fb, true, i)) {
            count += 1;
          }
        });
      }
      if (fb.economie || fb.type === 'BELASTING') {
        if (!checkRead(fb, false, 0, this.props.gameState.currentStep !== 2 && fb.economie)) {
          count += 1;
        }
      }
      return count;
    }, 0);
  }

  allowSave = () => {
    const { gameState, gameStateInput, policyChoice } = this.props;

    //Min policy cost
    const problems = groupByProblem(policyChoice);
    const minChoices = this.props.project.minPolicyChoices;
    let minGlb = 0;
    for (let i = 0; i < minChoices; i++) {
      if(!problems || !problems[i]) continue;
      minGlb += (Math.min(...getOplossingen(policyChoice, problems[i].Nummer, gameState.language).map(c => parseInt(c.kosten, 10))) || null);
    }

    //Startbudget
    const budget = gameState.totalGameStateSum.globas + getSavedGlobas(gameState, []);
    if(minGlb > budget && minGlb !== 0) {
      return true;
    }

    if (gameState.difficulty === 'BASIC' && choicesToMake(policyChoice, gameStateInput.myState.policyChoices, this.props.project.minPolicyChoices) > 0) {
      return false;
    }
    return true;
  }

  getSaveButton = (desktop) => {
    const { gameState, policyChoice, gameStateInput } = this.props;
    const { myState } = gameStateInput;
    if(!myState) return null;
    const { ministerieGlobaVerdeling } = myState;
    const savingsAndLoans = calculateSavingsAndLoans(gameStateInput);

    if(this.props.gameState.difficulty === "PRO"){
      //Pro
      const globas = calculateBudgetPRO(gameState, gameStateInput, myState.policyChoices, ministerieGlobaVerdeling, savingsAndLoans);
      if(gameState.currentStep === 3 && gameState.roundData.state === 'SIMULATION_SPENDING' && myState.SIMULATION_SPENDING !== 'PROCESSED') {
        if(desktop) {
          return (
            <div className="buttonWrap desktop">
              {this.props.user.role === 'groupleader' ? (
                  <button
                      onClick={(ev) => {
                        ev.preventDefault();
                        if (globas > 0) {
                          this.setState({showWarningId: 'dhgmstap3verdelingopslaan'});
                          return;
                        }
                        // @todo conditional
                        if (globas <= 0 && this.props.user.role === 'groupleader' && !gameStateInput.preventInputChanges) {
                          this.props.dispatch(submitMyState('SIMULATION_SPENDING'));
                        }
                      }}
                      className={`main-save-button button${globas <= 0 && !gameStateInput.preventInputChanges ? '' : ' disabled pointer-events'}`}
                  >
                    <span>{__('sim_verdling_opslaan_button')}</span>
                  </button>
              ) : null}
            </div>
          );
        } else {
          if (window.location.pathname !== '/' || this.props.user.role !== 'groupleader') return null;
          return (
            <div className={`footer-next-step saveStep ${globas <= 0 && !gameStateInput.preventInputChanges ? '' : ' inactive disabled pointer-events'}`}>
              <div className="triangle"/>
                <div
                  className="stepcircle"
                  onClick={(ev) => {
                    ev.preventDefault();
                    if (globas > 0) {
                      this.setState({showWarningId: 'dhgmstap3verdelingopslaan'});
                      return;
                    }
                    // @todo conditional
                    if (globas <= 0 && this.props.user.role === 'groupleader' && !gameStateInput.preventInputChanges) {
                      this.props.dispatch(submitMyState('SIMULATION_SPENDING'));
                    }
                  }}
                >
                  <span className="circle-bg save">
                    <img src={Save} alt="Save"/>
                  </span>
                </div>
            </div>
          )
        }
      }
    } else {
      //Basic
      const globas = calculateBudgetBASIC(gameState, myState.policyChoices, ministerieGlobaVerdeling, savingsAndLoans, policyChoice);
      if(gameState.currentStep === 3 && gameState.roundData.state === 'SIMULATION_SPENDING' && myState.SIMULATION_SPENDING !== 'PROCESSED') {
        if(desktop) {
          return (
            <div className="buttonWrap desktop">
              {this.props.user.role === 'groupleader' ? (
                <button
                    onClick={(ev) => {
                      ev.preventDefault();
                      if (globas > 0) {
                        this.setState({showWarningId: 'dlgmstap3verdelingopslaan'});
                        return;
                      }
                      if (globas <= 0 && !this.allowSave()) {
                        this.setState({showWarningId: 'dlgmstap3verdelingopslaan_1'});
                        return;
                      }
                      // @todo conditional
                      if (globas <= 0 && this.allowSave() && this.props.user.role === 'groupleader' && !gameStateInput.preventInputChanges) {
                        this.props.dispatch(submitMyState('SIMULATION_SPENDING'));
                      }
                    }}
                    className={`main-save-button button${globas <= 0 && this.allowSave() && !gameStateInput.preventInputChanges ? '' : ' disabled pointer-events'}`}
                  >
                  <span>{__('sim_verdling_opslaan_button')}</span>
                </button>
              ) : null}
            </div>
          )
        } else {
          if (window.location.pathname !== '/' || this.props.user.role !== 'groupleader') return null;
          return (
            <div className={`footer-next-step saveStep ${globas <= 0 && this.allowSave() && !gameStateInput.preventInputChanges ? '' : ' inactive disabled pointer-events'}`}>
              <div className="triangle"/>
              <div
                className="stepcircle"
                onClick={(ev) => {
                  ev.preventDefault();
                  if (globas > 0) {
                    this.setState({showWarningId: 'dlgmstap3verdelingopslaan'});
                    return;
                  }
                  if (globas <= 0 && !this.allowSave()) {
                    this.setState({showWarningId: 'dlgmstap3verdelingopslaan_1'});
                    return;
                  }
                  // @todo conditional
                  if (globas <= 0 && this.allowSave() && this.props.user.role === 'groupleader' && !gameStateInput.preventInputChanges) {
                    this.props.dispatch(submitMyState('SIMULATION_SPENDING'));
                  }
                }}
              >
                  <span className="circle-bg save">
                    <img src={Save} alt="Save"/>
                  </span>
              </div>
            </div>
          )
        }
      }
    }
    return null;
  }

  render() {
    const { showPopUp } = this.state;
    const { gameState } = this.props;
    if (!gameState.loaded || gameState.currentRound > 4) {
      //Terug naar startscherm button
      return (
        <div className={"footer-next-step footer-next-step--portal"}>
          <button onClick={() => history.push('/portal')}>
            <span>{__("sim_terug_naar_startscherm")}</span>
          </button>
        </div>
      )
    };
    if(gameState.currentStep >= 3) {
      return (
        <span>
          {this.getSaveButton(desktop)}
          {this.state.showWarning.length ? (
            <PopUp
                img={Warning}
                popUpFooter={true}
                description={__(this.state.showWarning)}
                closePopUpClick={() => this.setState({ showWarning: '' })}
            />
          ) : null}
          {this.state.showWarningId.length ? (
            <PopUp
              img={Warning}
              popUpFooter={true}
              id={this.state.showWarningId}
              closePopUpClick={() => this.setState({ showWarningId: '' })}
            />
          ) : null}
        </span>
      );
    }
    return (
      <div>
        <div className={"footer-next-step" + (this.unlocked ? '' : ' inactive')}>
          <div className="triangle"/>
          <div className="stepcircle" onClick={this.handleClick}>
            <span className="circle-bg">
              <p>{__('sim_stap')}<br/><span>{gameState.currentStep + 1}</span></p>
            </span>
          </div>
        </div>
        { showPopUp && !this.unlocked ? (
          <PopUp popUpFooter={true} id={(this.getDescription()).id ? (this.getDescription()).id : undefined } description={(this.getDescription()).desc ? (this.getDescription()).desc : undefined } closePopUpClick={this.togglePopUp}/>
        ) : null }
      </div>
    )
  }
}

export default connect(state => ({
  gameState: state.gameState,
  gameStateInput: state.gameStateInput,
  feedback: state.feedback,
  user: state.user,
  project: state.project,
  policyChoice: state.policyChoice,
}))(NextStep);



// WEBPACK FOOTER //
// ./src/components/elements/NextStep.js